import { render, staticRenderFns } from "./IncidentReportHistoryTable.vue?vue&type=template&id=60d2112c"
import script from "./IncidentReportHistoryTable.vue?vue&type=script&lang=js"
export * from "./IncidentReportHistoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports